const carouselSelector = document.querySelector(
  "body.homepage #our-work .carousel .slides",
);

if (carouselSelector) {
  // Ensure the element exists and has content
  if (carouselSelector.children.length > 0) {
    try {
      new Glider(carouselSelector, {
        // `auto` allows automatic responsive
        // width calculations
        slidesToShow: 1,
        slidesToScroll: 1,

        // should have been named `itemMinWidth`
        // slides grow to fit the container viewport
        // ignored unless `slidesToShow` is set to `auto`
        itemWidth: undefined,

        // if true, slides wont be resized to fit viewport
        // requires `itemWidth` to be set
        // * this may cause fractional slides
        exactWidth: false,

        // speed aggravator - higher is slower
        duration: 0.5,

        // dot container element or selector
        // dots: "CSS Selector",

        // arrow container elements or selector
        arrows: {
          prev: "#our-work .prev",
          next: "#our-work .next",
        },

        // allow mouse dragging
        draggable: false,
        // how much to scroll with each mouse delta
        dragVelocity: 3.3,

        // use any custom easing function
        // compatible with most easing plugins
        easing: function (x, t, b, c, d) {
          return c * (t /= d) * t + b;
        },

        // event control
        scrollPropagate: false,
        eventPropagate: true,

        // Force centering slide after scroll event
        scrollLock: false,
        // how long to wait after scroll event before locking
        // if too low, it might interrupt normal scrolling
        scrollLockDelay: 200,

        // Force centering slide after resize event
        resizeLock: true,

        // Rewind to first item when clicking next with no more items
        rewind: true,

        // Glider.js breakpoints are mobile-first
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],

        // Add error handling
        onError: (error) => {
          console.error("Glider error:", error);
        },
      });
    } catch (error) {
      console.error("Failed to initialize carousel:", error);
    }
  } else {
    console.warn("Carousel slides container is empty");
  }
}
